import { NoggleIcon } from "assets/icons";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import Noggle from "./Noggle";
import { NoggleSetting } from "./NoggleSetting";

export const NoggleWidget: WidgetType = {
  name: "Noggle",
  component: Noggle,
  icon: NoggleIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 82,
    minHeight: 100,
    minAspectRatio: 0.82,
    maxAspectRatio: 0.82,
  },
  defaultState: {
    grid: 3,
    selectedIndex: null,
    selectedColor: {},
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 30,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Generate random numbers in 3*3 or 4*4 or 5*5 grid.",
      },
    },
    grid: {
      defaultValue: {
        grid: 3,
        range: [1, 9],
        selectedRange: 9,
        selectedIndex: null,
        selectedColor: {},
      },
      editor: NoggleSetting,
      info: {
        label: "Grid",
        secondaryLabel: "Range",
      },
    },
  },
  quickActions: {},
};
